/* eslint-disable react-hooks/set-state-in-effect */
import CloseIcon from "@mui/icons-material/Close";
import {
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  Toolbar,
  IconButton,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

interface TabItem {
  label: string;
  path: string;
  disabled?: boolean;
}

interface TabbedLayoutProps {
  title?: string;
  tabs: TabItem[];
  basePath: string;
  backPath?: string;
  header?: boolean;
  getCurrentTabIndex: (pathname: string, tabs: TabItem[]) => number;
  
}

const TabbedLayout: React.FC<TabbedLayoutProps> = ({
  title,
  tabs,
  basePath,
  backPath,
  header,
  getCurrentTabIndex,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  // Get the current path to determine the active tab
  const [tabValue, setTabValue] = useState<number>(() => {
    const index = getCurrentTabIndex(location.pathname, tabs);
    return index === -1 ? 0 : index;
  });

  useEffect(() => {
    const index = getCurrentTabIndex(location.pathname, tabs);
    setTabValue(index === -1 ? 0 : index);
    // sessionStorage.setItem("lastVisitedPath", location.pathname)
  }, [location.pathname, tabs, getCurrentTabIndex]);


  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    navigate(`${basePath}/${tabs[newValue].path}`, {
      state: location.state,
    });
  };

  const handleNavigateBack = () => {
    if (!backPath) return;
    navigate(backPath, { state: location.state });
  };

  return (
    <Box sx={{ width: "100%" }}>
      {header && (title || backPath) && (
        <AppBar position="static" sx={{ backgroundColor: `${theme.palette.background.main}`, boxShadow: 0 }}>
          <Toolbar>
            {title && (
              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                {title}
              </Typography>
            )}
            {backPath && (
              <IconButton color="inherit" onClick={handleNavigateBack}>
                <CloseIcon />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      )}

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          backgroundColor: `${theme.palette.background.main}`,
          color: "white",
          "& .MuiTabs-indicator": { backgroundColor: "transparent" },
          // p: "5px 5px 0 5px",
          px: 3,
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.label}
            label={tab.label}
            disabled={tab.disabled}
            sx={{
              color: "white",
              backgroundColor: tabValue === index ? "white" : theme.palette.background.main,
              transition: "all 0.3s ease-in-out",
              "&.Mui-selected": {
                color: "#1976D2",
                fontWeight: "bold",
                backgroundColor: "white",
              },
            }}
          />
        ))}
      </Tabs>

      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default TabbedLayout;
